import React from 'react';
import PropTypes from 'prop-types';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaFeature from 'marketing-website/components/modules/Media/MediaFeature';

import assets from 'marketing-website/configs/pages/features/handoff/assets';

export default function Design({ color }) {
  return (
    <Spacing type="padding" size="xl" position="top">
      <Spacing type="padding" size="l" sizeM="0" position="bottom">
        <HeadingBlock
          title="Handoff works with Sketch or designs created in Marvel"
          justifyContent="center"
          justifyM="center"
          size="l"
          copy={
            <span>
              No need to change the way you work, our UI handoff tool works
              seamlessly with the design tools you know and love - like Sketch.
              <br />
              <br />
              Our Sketch plugin makes it effortless for you to keep designs in
              sync with Marvel, and now Handoff takes care of taking your
              prototypes into the development stage. With Marvel you can
              accelerate your entire designer developer handoff process.
            </span>
          }
        />
      </Spacing>
      <MediaFeature
        {...assets.browser}
        pattern={false}
        backgroundColor={color}
        patternTop="50%"
        patternLeft="35%"
      />
    </Spacing>
  );
}

Design.propTypes = {
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/pages/features/handoff/Design.js